<template>
    <v-navigation-drawer
        :value="drawerRightVisible"
        @input="toggleDrawerRight($event)"
        right
        temporary
        fixed
        width="500"
    >

    <component :is="currentDrawerRight.component" v-if="drawerRightVisible"></component>
    
    </v-navigation-drawer>
</template>

<script>
// TODO: It would make sense, if we would load components dynamically, because we maybe dont know which component would be injected
import VerticalStepperComponent from "@/components/snippets/VerticalStepper.vue";
import ActivityStream from "@/components/widgets/AuditActivityStream.vue";

import { mapState, mapActions } from "vuex";
import { api } from "@/store/modules/app";

export default {
  components: {
    VerticalStepperComponent,
    ActivityStream
  },
  computed: {
    ...mapState(api.namespace, [
      api.state.drawerRightVisible,
      api.state.drawerRight
    ]),
    currentDrawerRight() {
      if (this.drawerRight.component) {
        return this.drawerRight;
      } else {
        return { component: "VerticalStepperComponent" };
      }
    }
  },
  methods: {
    ...mapActions(api.namespace, [api.mutations.toggleDrawerRight])
  }
};
</script>
